import {
  requiredPageFields,
  optionalPageFields,
} from 'src/app/shared/constants/formDataFields';
import { PAGE_ID_CLASSIFY } from 'src/app/shared/constants/pageUid';
import type { FormData } from 'src/types/appState';

import checkIfFieldPopulated from '../checkIfFieldPopulated';

const CLASSIFY_PAGE_FIELDS = requiredPageFields[PAGE_ID_CLASSIFY];

const isClassifyPageComplete = (formData?: FormData) =>
  CLASSIFY_PAGE_FIELDS.every(
    (field: string) =>
      checkIfFieldPopulated(formData, field) ||
      optionalPageFields.includes(field),
  );

export default isClassifyPageComplete;
